import { FC } from 'react';
import ConfigureItemsGrid from '@flows/src/components/flows-configure/shared/ConfigureItemsGrid';
import FlowsConfigureInsuranceGroupItem from '@flows/src/components/flows-configure/insurances/FlowsConfigureInsuranceGroupItem';
import SelectAllButton from '@flows/src/components/flows-configure/shared/SelectAllButton';
import { useAnvaFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/anvaFlowsConfigureStore';
import { AnvaFlowsInsuranceTag } from '@flows/src/api/anva-flows/getAnvaFlowsInsuranceTags';

interface Props {
  items: AnvaFlowsInsuranceTag[];
  isError?: boolean;
  clearError?: () => void;
}

const FlowsConfigureInsuranceGroupItems: FC<Props> = ({
  items,
  isError,
  clearError,
}) => {
  const setInsurances = useAnvaFlowsConfigureStore(
    (state) => state.setInsurances,
  );
  const isAllSelected = useAnvaFlowsConfigureStore(
    (state) => state.insurances?.length === items.length,
  );

  const handleSelectAllGroups = () => {
    setInsurances(items);
  };
  const handleDeselectAll = () => {
    setInsurances([]);
  };

  return (
    <ConfigureItemsGrid singleColumn={items.length === 1}>
      {items.length > 1 && (
        <SelectAllButton
          isAllSelected={isAllSelected}
          onDeselectAll={handleDeselectAll}
          onSelectAll={handleSelectAllGroups}
        />
      )}
      {items.map((item) => (
        <FlowsConfigureInsuranceGroupItem
          key={item.id}
          insuranceGroup={item}
          isError={isError}
          clearError={clearError}
        />
      ))}
    </ConfigureItemsGrid>
  );
};

export default FlowsConfigureInsuranceGroupItems;
